var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.folder?.id)?_c('div',{staticClass:"view d-flex w-100"},[(_vm.isFolder)?_c('folder-view',{attrs:{"folder":_vm.folder}}):_c('assignment-view')],1):_c('div',[_c('eg-b-overlay',{attrs:{"show":true,"no-wrap":""},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('eg-b-spinner',{attrs:{"small":"","variant":"info"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }